import { InjectionToken } from '@angular/core';

export const USER_GA_PROPERTY = new InjectionToken<string>('USER_GA_PROPERTY', {
  factory: () => {
    console.warn(
      'USER_GA_PROPERTY is not provided — GA events for the user menu will not be routed to any property.',
    );
    return '';
  },
});

const _USER_GA_BASE = 'show_profile';

export const UserMenuClickListener = {
  navigateToIdentityProfile: `${_USER_GA_BASE}_navigate_to_is_profile`,
  navigateToPat: `${_USER_GA_BASE}_navigate_to_pat`,
  openPrivacy: `${_USER_GA_BASE}_open_privacy_policy`,
  openTos: `${_USER_GA_BASE}_open_tos`,
  logout: `${_USER_GA_BASE}_logout`,
} as const;
